<template>
  <popper class="plep" trigger="clickToOpen" ref="inventoryBox" @show="getData()" :options="{ placement: 'top', modifiers: { offset: { offset: '0,10px' } } }">
    <div class="popper">
      <h3>Manage inventory</h3>
      <br />
      <select v-model="selected">
            <option
              :disabled="option.id == 0"
              v-for="(option, index) in inventory"
              :key="index"
              :value="option.id"
              :data-stock="option.stock"
            >
              {{ option.text }}
            </option>
          </select>
      <label>
            <input
              :disabled="disableAutoInventory"
              v-model="autoInventory"
              type="checkbox" />Disable Auto Web Inventory for Product</label><br />
          <button class="saveBtn" @click="updateStock">Save</button>
        </div>
        <button class="invBtn" slot="reference">
          <svg class="fontAwesomeIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/></svg>
          <!-- <font-awesome-icon :icon="['fas', 'cog']" /> -->
          
        </button>
      </popper>
</template>

<script>
  // CODE SPLITTING - There is linking issues when in development.
    // The chunks cannot handle our /pndk/ stuff
  //const Popper = ()=> import('vue-popperjs');

  import Popper from "vue-popperjs";
  import "vue-popperjs/dist/vue-popper.css";
  export default {
    props: ["name", "id"],
    components: {
      popper: Popper,
    },
    data() {
      return {
        selected: {},
        inventory: [],
        autoInventory: null,
        disableAutoInventory: "",
      };
    },
    methods: {
      getData: function() {
        this.inventory = [];
        this.selected = {};
        this.autoInventory = null;
        axios
          .get(
            window.basedir + "/ajaxRequestServlet", {
              params: {
                mode: "RetrieveWebProductStatus",
                productId: this.id,
              },
            }, {
              headers: {
                "Content-type": "application/json",
              },
            }
          )
          .then((response) => {
           // console.log(response.data);
            this.autoInventory = response.data.isDisableAutoInventoryCheckProduct;
            this.disableAutoInventory = !response.data.isAutoCheckInventory
              ;
            if (response.data.currentProdAvailableStatusID == 0) {
              this.inventory.push({
                text: "STATUS NOT SET",
                id: 0,
                stock: 0,
              });
            }
            response.data.prodAvailableArr.forEach((element) => {
              this.inventory.push({
                text: element.value,
                id: element.id,
                stock: element.valueNumber,
              });
            });
            this.selected = this.inventory.find(
              (x) => x.id == response.data.currentProdAvailableStatusID
            ).id;
          });
      },
      updateStock: function() {
        axios
          .get(
            window.basedir + "/ajaxRequestServlet", {
              params: {
                mode: "ManageInventory",
                productId: this.id,
                productAvailablityStatus: this.inventory.find(
                  (x) => x.id == this.selected
                ).id,
                disableAutoInventory: this.autoInventory ? "on" : null,
              },
            }, {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }
          )
          .then((response) => {
            this.$refs.inventoryBox.showPopper = false;
            this.$store.dispatch(
              "getPriceList", !this.$root.settings.showFilter ? this.$root.settings.showCat : []
            );
            alertify
              .logPosition("bottom right")
              .closeLogOnClick(true)
              .delay(0)
              .success(
                '<i style="color:#67ad45 !important;padding-right: 3px;" class="fa fa-check" aria-hidden="true"></i> ' +
                "<strong>" +
                this.name +
                ": </strong>" +
                this.inventory.find((x) => x.id == this.selected).text
              );
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  button {
    cursor: pointer;
  }
  select {
    width: 100%;
    max-width: 568px;
  }
  .invBtn {
    display: block;
    margin-left: 4px;
    color: #004570;
    cursor: pointer;
    border: none;
    z-index: 100;
    padding: 0;
    font-size: 1.3em;
  }
  .popper {
    padding: 14px;
    width: auto;
    min-width: 29%;
  }
  .saveBtn {
    background: #7caf63;
    border: none;
    padding: 9px;
    color: white;
    border-radius: 4px;
  }
  option {
    text-align: center;
  }
  input {
    background: white;
  }
  .plep {
    float: right;
  }
  label {
    cursor: pointer;
  }
</style>